import styled from 'styled-components';

export const Container = styled.div`
    display:flex;
    flex-direction: column;
`

export const Title = styled.div`
    width:400px;
    margin-bottom : 20px;
`

export const Time = styled.h1`
    color : white;
    font-family: 'KCC-Ganpan';
    font-size : 2em;
    text-align : center;
    user-select : none;
`

export const WrapContent = styled.div`

`